import RestLink from './RestLink';

import type {InteropFields} from '../../../../shared/graphql/links/RestLink/rewriteInteropParams';
import type {
  UnionObjectTypesMap,
  FieldVersionOverrides,
} from '../../../../shared/graphql/links/RestLink/types';
import type {TopLevelFieldToArgs} from '../../../../shared/graphql/links/RestLink/removePbeFromParams';

export default function createRestLink(
  unionObjectTypesMap: UnionObjectTypesMap,
  pbeMap: Record<string, ReadonlyArray<string>>,
  topLevelFieldToArgs: TopLevelFieldToArgs,
  fieldVersionOverrides: FieldVersionOverrides,
  queryEndpointsToBeRequestedWithPost?: string[],
  interopFields?: InteropFields,
): RestLink {
  return new RestLink(
    unionObjectTypesMap,
    pbeMap,
    topLevelFieldToArgs,
    fieldVersionOverrides,
    queryEndpointsToBeRequestedWithPost,
    interopFields,
  );
}
